// elosztó
import '../c/layoutid_RWM001.pcss';
import './globals/links';
import './components/roaming-app';
import './modules/m28-personalized-device-pager';
import './modules/m22-drop-down-textblock';
import './modules/m19-clickable-list';
import './modules/m07-tertiary-link-collection';
import './modules/m27-video-gallery';
import './modules/m15-one-column-descriptive';
import './modules/m16-multi-column-descriptive';
import './modules/m13-inline-promo';
import './modules/m13p-inline-promo';
import './modules/m09-device-card';
import './modules/m09p-device-card';
import './modules/m14-connection';
import './modules/m20-tabbed-container';
import './modules/m21-tabbed-container-extended';
import './modules/m02-notification-bar';
import './modules/m23-brutto-netto';
import './modules/m17-horizontal-redirector';
import './modules/m17p-horizontal-redirector';
import './modules/m12-prod-offer';
import './modules/m10-header-promo';
import './modules/m25-flowtext';
import './modules/m11p-device-card';
import { triggerWc } from './common/trigger-wc';
triggerWc();
